// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import GoogleLoginButton from '../components/GoogleLoginButton';

import { jwtDecode } from 'jwt-decode';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || 'Login failed');
      }
      const data = await response.json();
      // Store the token for future API calls
      localStorage.setItem('token', data.token);
      // Decode the token to extract user info
      try {
        const decodedUser = jwtDecode(data.token);
        localStorage.setItem('user', JSON.stringify(decodedUser));
      } catch (decodeError) {
        console.error('Error decoding token:', decodeError);
        localStorage.removeItem('user');
      }
      // Redirect to feed
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
  };
  
  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow rounded">
      <h1 className="text-2xl font-bold mb-4">Login</h1>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      <form onSubmit={handleSubmit}>
        <label className="block mb-2">
          Email:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border p-2 mt-1 rounded"
            required
          />
        </label>
        <label className="block mb-4">
          Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border p-2 mt-1 rounded"
            required
          />
        </label>
        <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded">
          Login
        </button>
      </form>
      <hr className="my-4" />
      <div className="text-center">
        <p className="mb-2">Or login with:</p>
        <a 
          href={`${process.env.REACT_APP_API_URL}/auth/google/login`} 
          className="inline-block bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
        >
          Sign in with Google
        </a>
      </div>
    </div>
  );
};

export default Login;
